import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../components/common/Sidebar";
import { getNewsEvents, getMediaUrl } from "../services/catalogueService";
import "./News.css";

export default function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const data = await getNewsEvents();
        setNews(data.filter(item => item.isActive).sort((a, b) => (a.sequence || 0) - (b.sequence || 0)));
      } catch (error) {
        console.error("Failed to fetch news:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  return (
    <>
      <Sidebar />
      <main className="content-area">
        <section className="news-page-panel">
          <div className="news-page-header-bar">
            <h2>News</h2>
          </div>

          <div className="news-page-list-container">
            {loading ? (
              <p className="loading-text">Loading news...</p>
            ) : news.length > 0 ? (
              <ul className="news-bullet-list">
                {news.map((item) => (
                  <li key={item._id}>
                    <Link to={`/news/${item.slug || item._id}`}>
                      {item.title || item.Title}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="no-data-text">No news available at the moment.</p>
            )}
          </div>
        </section>
      </main>
    </>
  );
}
